/**
 * Floor Check access allowlist.
 *
 * Per Jake (Feb 2026): "You can hide the floor check from dashboards for now."
 *   → Allowlist emptied so the Floor tab, bottom-nav button, /daily-floor-check
 *     route, and standalone page are hidden from every user. The underlying
 *     component and backend endpoint are left intact for a quick re-enable —
 *     just add the operator's name back to FLOOR_CHECK_ALLOWED_NAMES below.
 *
 * Prior allowlist (kept for reference): ["mason reeves", "kyle straight"].
 *
 * Frontend gate only — controls tab visibility on DetailerDashboard, the
 * /daily-floor-check route, and the standalone DailyFloorCheck page. The
 * backend `/api/shop/daily-floor-check` endpoint remains open to any
 * authenticated user (no PII; it's just a stock checklist).
 */
const FLOOR_CHECK_ALLOWED_NAMES = [];

export function canAccessFloorCheck(user) {
  if (!user) return false;
  const name = (user.name || "").trim().toLowerCase();
  return FLOOR_CHECK_ALLOWED_NAMES.includes(name);
}
